export default "__VITE_PUBLIC_ASSET__f3a038b2__"